import api from "@/api";

export default {
  namespaced: true,
  state: () => ({
    examSchedules: [],
    loading: false,
    error: null
  }),
  mutations: {
    SET_EXAM_SCHEDULES(state, examSchedules) {
      state.examSchedules = Array.isArray(examSchedules) ? examSchedules : [];
    },
    ADD_EXAM_SCHEDULE(state, examSchedule) {
      state.examSchedules.push(examSchedule);
    },
    UPDATE_EXAM_SCHEDULE(state, updatedExamSchedule) {
      const index = state.examSchedules.findIndex(s => s.id === updatedExamSchedule.id);
      if (index !== -1) {
        state.examSchedules.splice(index, 1, updatedExamSchedule);
      }
    },
    DELETE_EXAM_SCHEDULE(state, examScheduleId) {
      state.examSchedules = state.examSchedules.filter(s => s.id !== examScheduleId);
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
  async fetchClassExamSchedules({ commit }, { classId, exam_type_id, exam_date }) {
  commit('SET_LOADING', true);
  try {
    let url = `classes/${classId}/exam-schedules`;
    const params = new URLSearchParams();
    
    if (exam_type_id) params.append('exam_type_id', exam_type_id);
    if (exam_date) params.append('exam_date', exam_date);
    
    if (params.toString()) url += `?${params.toString()}`;
    
    const response = await api.get(url);
    
    // Ensure we always return an array
    let data = response.data?.data || response.data;
    if (!Array.isArray(data)) {
      data = [];
    }
    
    commit('SET_EXAM_SCHEDULES', data);
    return data;
    
  } catch (error) {
    commit('SET_ERROR', error);
    throw error;
  } finally {
    commit('SET_LOADING', false);
  }
},
    
    async createExamSchedule({ commit }, { classId, data }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.post(
          `classes/${classId}/exam-schedules`,
          data
        );
        const examSchedule = response.data.data || response.data;
        commit('ADD_EXAM_SCHEDULE', examSchedule);
        return examSchedule;
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async updateExamSchedule({ commit }, { classId, id, data }) {
      commit('SET_LOADING', true);
      try {
        const updateData = {
          ...data,
          _method: 'PUT',
          exam_schedule_id: id
        };
        
        const response = await api.put(
          `classes/${classId}/exam-schedules/${id}`,
          updateData
        );
        const examSchedule = response.data.data || response.data;
        commit('UPDATE_EXAM_SCHEDULE', examSchedule);
        return examSchedule;
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async deleteExamSchedule({ commit }, { classId, id }) {
      commit('SET_LOADING', true);
      try {
        await api.delete(`classes/${classId}/exam-schedules/${id}`);
        commit('DELETE_EXAM_SCHEDULE', id);
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    classExamSchedules: (state) => (classId) => {
      return Array.isArray(state.examSchedules) ? state.examSchedules.filter(s => s.class_id == classId) : [];
    },
    isLoading: (state) => state.loading,
    error: (state) => state.error
  }
};